import { TemplateRef, ɵstringify as stringify } from '@angular/core';

export class IfHasEntitlementContext {
	public entitlement: string = null;
	public entitlements: string[] | { entitlementType: string; entitlementName: string }[];

	public hasEntitlement: boolean = false;
	public additionalCondition: boolean = false;
	public additionalConditionType: string;

	get conditionsMet(): boolean {
		if (!this.additionalConditionType) {
			return this.hasEntitlement;
		} else if (this.additionalConditionType === 'and') {
			return this.hasEntitlement && this.additionalCondition;
		} else if (this.additionalConditionType === 'or') {
			return this.hasEntitlement || this.additionalCondition;
		}
	}
}

export function assertTemplate(property: string, templateRef: TemplateRef<any> | null): void {
	const isTemplateRefOrNull = !!(!templateRef || templateRef.createEmbeddedView);
	if (!isTemplateRefOrNull) {
		throw new Error(`${property} must be a TemplateRef, but received '${stringify(templateRef)}'.`);
	}
}
